export const GALLERY_REVIEW_ITEM_MODAL_NAME = 'REVIEW_IN_IMAGE_CAROUSEL'
